import { OnboardThemeEdit, defaultEdits } from "../helpers/batchEditing";

export interface ThemeStyles {
    borderRadius?: string;
    boxShadow?: string;
    border?: string;
    background?: string;
}

export interface LayoutStyle {
    id: string;
    name: string;
    themeStyles: ThemeStyles;
    themeEdits?: OnboardThemeEdit[];
}

export const layoutStyles: LayoutStyle[] = [
    {
        id: "curved_shadow",
        name: "Slightly curved with shadow",
        themeStyles: {
            borderRadius: "8px",
            boxShadow: "0px 8px 16px 0px #3E134D12"
        },
        themeEdits: defaultEdits
    },
    {
        id: "fully_rounded",
        name: "Fully Rounded",
        themeStyles: {
            borderRadius: "50px",
            boxShadow: "0px 8px 16px 0px #3E134D12"
        },
        themeEdits: [
            { key: "buttons", update: { propertyPath: ["attr", "style"], value: { borderRadius: "100px 100px 100px 100px" } } },
            { key: "productVariations", update: { propertyPath: ["inputStyles"], value: { borderRadius: "100px 100px 100px 100px" } } },
            { key: "productQuantity", update: { propertyPath: ["buttonStyle"], value: { borderRadius: "100px 100px 100px 100px" } } },
            { key: "customNumpad", update: { propertyPath: ["keyStyle"], value: { borderRadius: "100px 100px 100px 100px" } } },
            { key: "searchField", update: { propertyPath: ["attr", "style"], value: { borderRadius: "100px 100px 100px 100px" } } },
            {
                key: "directChildrenOfRepeaterInProductGrid",
                update: { propertyPath: ["attr", "style"], value: { borderWidth: "0px" } }
            },
            {key: "productGridRepeater", update: { propertyPath: ["attr", "style", "boxShadow"], value: undefined, remove: true } },
            { key: "orderListRepeater", update: { propertyPath: ["attr", "style"], value: { borderRadius: "100px 100px 100px 100px", padding: "0px 16px 0px 24px" } } },
            { key: "customerListRepeater", update: { propertyPath: ["attr", "style"], value: { borderRadius: "100px 100px 100px 100px", padding: "0px 8px 0px 8px" } } },
            {
                key: "allProductImages",
                update: { propertyPath: ["attr", "style"], value: { borderRadius: "100px 100px 100px 100px", width: "180px", height: "180px" } }
            },
            {key: "divsThatHaveEitherBGColororBorders", update: { propertyPath: ["attr", "style"], value: { borderRadius: "16px 16px 16px 16px" } } },
            {key: "carts", update: { propertyPath: ["customerChip"], value: { borderRadius: "16px 16px 16px 16px" } } },
            { key: "productImageInRepeaterInOrderData", update: { propertyPath: ["attr", "style"], value: { borderRadius: "100px 100px 100px 100px", width: "80px", height: "80px" } } },
            { key: "radioField", update: { propertyPath: ["radioStyle"], value: { borderRadius: "100px 100px 100px 100px" } } }
        ]
    },
    {
        id: "slate",
        name: "Slate",
        themeStyles: {
            borderRadius: "12px 0 12px 0",
            boxShadow: "0px 8px 16px 0px #3E134D12"
        },
        themeEdits: [
            {
                key: "orderListRepeater",
                update: { propertyPath: ["attr", "style"], value: { borderRadius: "40px 0px 40px 0px", overflow: "hidden", padding: "0px 8px 0px 10px" } }
            },
            {
                key: "radioField",
                update: { propertyPath: ["radioStyle"], value: { borderRadius: "16px 0px 16px 0px" } }
            },
            {
                key: "customerListRepeater",
                update: { propertyPath: ["attr", "style"], value: { borderRadius: "40px 0px 40px 0px", overflow: "hidden", padding: "0px 8px 0px 24px" } }
            },
            { key: "allProductImages", update: { propertyPath: ["attr", "style"], value: { borderRadius: "24px 0px 24px 0px" } } },
            { key: "buttons", update: { propertyPath: ["attr", "style"], value: { borderRadius: "16px 0px 16px 0px" } } },

            { key: "productVariations", update: { propertyPath: ["inputStyles"], value: { borderRadius: "16px 0px 16px 0px" } } },
            { key: "searchField", update: { propertyPath: ["attr", "style"], value: { borderRadius: "16px 0px 16px 0px" } } },
            { key: "dropDownField", update: { propertyPath: ["attr", "style"], value: { borderRadius: "16px 0px 16px 0px" } } },
            { key: "productQuantity", update: { propertyPath: ["buttonStyle"], value: { borderRadius: "16px 0px 16px 0px" } } },

            { key: "customNumpad", update: { propertyPath: ["keyStyle"], value: { borderRadius: "16px 0px 16px 0px" } } },

            { key: "carts", update: { propertyPath: ["attr", "style"], value: { borderRadius: "40px 0px 40px 0px", padding: "24px" } } },
            {
                key: "productGridRepeater",
                update: { propertyPath: ["attr", "style"], value: { borderRadius: "40px 0px 40px 0px", overflow: "hidden" } }
            },
            { key: "divsThatHaveEitherBGColororBorders", update: { propertyPath: ["attr", "style"], value: { borderRadius: "40px 0px 40px 0px" } } }
        ]
    },
    {
        id: "sharp_outline",
        name: "Sharp with outline",
        themeStyles: {
            borderRadius: "0",
            border: "1px solid #E5E0EB"
        },
        themeEdits: [
            { key: "buttons", update: { propertyPath: ["attr", "style"], value: { borderRadius: "0px 0px 0px 0px" } } },
            { key: "productQuantity", update: { propertyPath: ["buttonStyle"], value: { borderRadius: "0px 0px 0px 0px" } } },
            { key: "customNumpad", update: { propertyPath: ["keyStyle"], value: { borderRadius: "0px 0px 0px 0px" } } },
            { key: "productVariations", update: { propertyPath: ["inputStyles"], value: { borderRadius: "0px 0px 0px 0px" } } },
            { key: "searchField", update: { propertyPath: ["attr", "style"], value: { borderRadius: "0px 0px 0px 0px" } } },
            { key: "radioField", update: { propertyPath: ["radioStyle"], value: { borderRadius: "0px 0px 0px 0px" } } },
            {key: "productGridRepeater", update: { propertyPath: ["attr", "style", "boxShadow"], value: undefined, remove: true } },
            { key: "dynamicGridsAndListsWrappers", update: { propertyPath: ["attr", "style"], value: { borderRadius: "0px 0px 0px 0px" } } },
            { key: "orderListRepeater", update: { propertyPath: ["attr", "style"], value: { borderRadius: "0px 0px 0px 0px", boxShadow: "none" } } },
            { key: "directChildrenOfRepeaterInProductGrid", update: { propertyPath: ["attr", "style"], value: { boxShadow: "none" } } },
            { key: "customerListRepeater", update: { propertyPath: ["attr", "style"], value: { borderRadius: "none" } } },
            { key: "customerListRepeater", update: { propertyPath: ["attr", "style"], value: { boxShadow: "none" } } },

            { key: "carts", update: { propertyPath: ["attr", "style"], value: { borderRadius: "0px 0px 0px 0px", borderWidth: "1px" } } },

            { key: "divsThatHaveEitherBGColororBorders", update: { propertyPath: ["attr", "style"], value: { borderRadius: "0px 0px 0px 0px" } } },

            {
                key: "productGridRepeater",
                update: { propertyPath: ["attr", "style"], value: { borderRadius: "0px 0px 0px 0px", borderWidth: "1px" } }
            },

            { key: "allProductImages", update: { propertyPath: ["attr", "style"], value: { borderRadius: "0px 0px 0px 0px" } } }
        ]
    }
];
